/**
 * Spline Scene Configuration
 * 
 * This file contains the mapping of page names to their corresponding Spline scene URLs.
 * You can easily change the 3D background for each page by updating the URLs here.
 * 
 * To get a new Spline scene URL:
 * 1. Create your scene in Spline (https://spline.design/)
 * 2. Export/publish your scene
 * 3. Copy the scene URL and add it to this configuration
 */

export const SPLINE_SCENES = {
  // Default scene (used by StatsAI and as fallback)
  default: "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode",
  
  // Company pages
  "About Us": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Same as default for now
  "Technology & Expertise": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Tech-themed scene
  "Vision 2030": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Future-themed scene
  "Careers": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Team/career-themed scene
  
  // Services pages
  "Services": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Service-themed scene
  "Solutions / Industries": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Industry-themed scene
  "Case Studies / Portfolio": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Portfolio-themed scene
  "Blog / Insights": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Blog-themed scene
  "Testimonials / Clients": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Client-themed scene
  
  // Get Started pages
  "Contact Us": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Contact-themed scene
  "Book a Consultation": "https://prod.spline.design/0mMSNhUsMcEDsegS/scene.splinecode", // Consultation-themed scene
  "Privacy Policy": null, // No Spline background for legal pages
  "Terms of Service": null, // No Spline background for legal pages
  
  // Team pages (using the custom team scene you provided)
  "Team Directory": "https://prod.spline.design/FLXziJwnaQS2OC4T/scene.splinecode", // Team-themed scene
  "Team Overview": "https://prod.spline.design/FLXziJwnaQS2OC4T/scene.splinecode", // Team-themed scene
  "Team Members": "https://prod.spline.design/FLXziJwnaQS2OC4T/scene.splinecode", // Team-themed scene
  "Team Performance": "https://prod.spline.design/FLXziJwnaQS2OC4T/scene.splinecode", // Team-themed scene
  "Team Tasks": "https://prod.spline.design/FLXziJwnaQS2OC4T/scene.splinecode", // Team-themed scene
  "Team Recruitment": "https://prod.spline.design/FLXziJwnaQS2OC4T/scene.splinecode", // Team-themed scene
};

/**
 * Get the Spline scene URL for a given page name
 * @param {string} pageName - The name of the page
 * @returns {string|null} - The Spline scene URL or null if no scene should be shown
 */
export const getSplineSceneUrl = (pageName) => {
  return SPLINE_SCENES[pageName] || SPLINE_SCENES.default;
};

/**
 * Check if a page should have Spline background enabled
 * @param {string} pageName - The name of the page
 * @returns {boolean} - Whether Spline should be enabled for this page
 */
export const shouldEnableSpline = (pageName) => {
  return SPLINE_SCENES[pageName] !== null;
};
